import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

import { Badge } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { MachinesFetchAPI } from '../../api/Machines';
import { ListGroup } from 'react-bootstrap';

//IMG
import vending_machine from '../img/vending-machine.jpg'

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .mvm-
───────────────────────────────────────────────────────── */
const MVM_CSS = `
@keyframes mvm-slide { from{opacity:0;transform:translateY(14px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }

/* ── TRIGGER ── */
.mvm-trigger {
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; border-radius: 9px; border: none; cursor: pointer;
  background: rgba(27,58,107,.09); color: #1B3A6B;
  transition: all .14s;
}
.mvm-trigger:hover { background: #1B3A6B; color: #fff; }

/* ── MODAL ── */
.mvm-dialog { max-width: 480px !important; }
.mvm-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 24px 64px rgba(0,0,0,.18), 0 6px 16px rgba(0,0,0,.07) !important;
  overflow: hidden !important;
  animation: mvm-slide .28s cubic-bezier(.34,1.56,.64,1) both !important;
}
.mvm-dialog .modal-body   { padding: 0 !important; }
.mvm-dialog .modal-header { display: none !important; }
.mvm-dialog .modal-footer { display: none !important; }

/* ── CUSTOM HEADER ── */
.mvm-head {
  display: flex; align-items: center; gap: .6rem;
  padding: 1rem 1.25rem .9rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%);
}
.mvm-head-ico {
  width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0;
  background: rgba(255,255,255,.13); color: #fff;
  display: grid; place-items: center;
}
.mvm-head-title {
  font-size: .93rem; font-weight: 700; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mvm-head-close {
  width: 28px; height: 28px; border-radius: 50%; margin-left: auto; flex-shrink: 0;
  border: 1.5px solid rgba(255,255,255,.22); background: rgba(255,255,255,.1);
  color: rgba(255,255,255,.8); display: grid; place-items: center;
  cursor: pointer; transition: all .14s;
}
.mvm-head-close:hover { background: rgba(239,68,68,.35); border-color: rgba(239,68,68,.5); }

/* ── IMAGE AREA ── */
.mvm-img-wrap {
  background: linear-gradient(135deg, rgba(27,58,107,.06) 0%, rgba(37,99,235,.04) 100%);
  padding: 1.25rem; display: flex; justify-content: center; align-items: center;
  border-bottom: 1px solid rgba(0,0,0,.07);
}
.mvm-img {
  width: 120px; height: 120px; object-fit: cover;
  border-radius: 14px; border: 2px solid rgba(0,0,0,.08);
  box-shadow: 0 4px 18px rgba(0,0,0,.13);
}

/* ── INFO GRID ── */
.mvm-info { padding: 1rem 1.25rem 1.1rem; display: flex; flex-direction: column; gap: .55rem; }

/* 2 cols on larger, 1 on small */
.mvm-info-row {
  display: grid; grid-template-columns: 1fr 1fr; gap: .55rem;
}
.mvm-info-row.single { grid-template-columns: 1fr; }

.mvm-info-cell {
  background: #F9FAFB; border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 10px; padding: .6rem .85rem;
  display: flex; flex-direction: column; gap: .15rem;
}
.mvm-info-label {
  font-size: .61rem; font-weight: 800; letter-spacing: .07em;
  text-transform: uppercase; color: #9CA3AF;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mvm-info-value {
  font-size: .86rem; font-weight: 700; color: #111827;
  font-family: var(--font-sans,-apple-system,sans-serif);
  word-break: break-word;
}
.mvm-info-value:empty::after { content: '—'; color: #C0C7D0; font-weight: 500; }

/* ── FOOTER ── */
.mvm-footer {
  display: flex; justify-content: flex-end;
  padding: .7rem 1.25rem .85rem;
  border-top: 1px solid rgba(0,0,0,.07);
}
.mvm-close-btn {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .52rem 1.2rem; border-radius: 9px; border: none;
  background: rgba(0,0,0,.06); color: #6B7280;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .82rem; font-weight: 600; cursor: pointer; transition: all .14s;
}
.mvm-close-btn:hover { background: rgba(0,0,0,.11); color: #374151; }

@media(max-width: 480px) {
  .mvm-dialog { max-width: calc(100vw - 1.5rem) !important; }
  .mvm-info-row { grid-template-columns: 1fr; }
}
`;

if (typeof window !== 'undefined' && !document.getElementById('mvm-styles')) {
  const el = document.createElement('style');
  el.id = 'mvm-styles'; el.textContent = MVM_CSS;
  document.head.appendChild(el);
}

/* ── ICONS ── */
const IcoEye = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoMachine = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="2" width="18" height="20" rx="2"/><path d="M8 2v20M3 8h5M3 12h5M3 16h5"/><rect x="11" y="6" width="6" height="4" rx="1"/><rect x="11" y="13" width="6" height="4" rx="1"/></svg>;
const IcoX    = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
function ModalviewMachine({ machine }) {

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [showModal, setShowModal] = useState(false)
  const [eventHandle, setEventHandle] = useState(0);
  const [infoMachine, setInfoMachine] = useState({
    branchoffice_id: "", code: "", description: "", machine_id: "",
    machine_name: "", machine_per_branch_id: "", machine_subtype_code: "",
    machine_subtype_id: "", name: "", subtype: ""
  })

  let token = localStorage.getItem("x-access-token")
  let user = localStorage.getItem('user');

  useEffect(() => {}, [eventHandle])
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      {/* ── TRIGGER ── */}
      <button
        className="mvm-trigger btn btn-outline-primary btn-sm border-0"
        onClick={() => (setShowModal(true), setInfoMachine(machine))}
        title="Ver detalles"
      >
        <IcoEye />
      </button>

      {/* ── MODAL ── */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        dialogClassName="mvm-dialog"
      >
        {/* encabezados originales de Bootstrap preservados (display:none en CSS) */}
        <Modal.Header className="text-center">
          <h3><i className="uil uil-eye" />Detalle de la maquina</h3>
        </Modal.Header>

        <Modal.Body>

          {/* ── HEADER VISUAL PROPIO ── */}
          <div className="mvm-head">
            <div className="mvm-head-ico"><IcoMachine /></div>
            <div className="mvm-head-title">Detalle de la máquina</div>
            <button className="mvm-head-close" type="button" onClick={() => setShowModal(false)}>
              <IcoX />
            </button>
          </div>

          {/* ── IMAGEN ── */}
          <div className="mvm-img-wrap">
            <img className="mvm-img imgEditModal" src={vending_machine} alt={infoMachine.machine_name || 'Vending machine'} />
          </div>

          {/* ── INFO — sin ListGroup, Container, Row, Col ── */}
          <div className="mvm-info">

            {/* Fila 1: Nombre + Tipo */}
            <div className="mvm-info-row">
              <div className="mvm-info-cell">
                <span className="mvm-info-label">Nombre</span>
                <span className="mvm-info-value">{infoMachine.machine_name}</span>
              </div>
              <div className="mvm-info-cell">
                <span className="mvm-info-label">Tipo</span>
                <span className="mvm-info-value">{infoMachine.name}</span>
              </div>
            </div>

            {/* Fila 2: Modelo (ancho completo) */}
            <div className="mvm-info-row single">
              <div className="mvm-info-cell">
                <span className="mvm-info-label">Modelo</span>
                <span className="mvm-info-value">{infoMachine.subtype}</span>
              </div>
            </div>

            {/* Fila 3: Code subtipo + Code */}
            <div className="mvm-info-row">
              <div className="mvm-info-cell">
                <span className="mvm-info-label">Code subtipo</span>
                <span className="mvm-info-value">{infoMachine.machine_subtype_code}</span>
              </div>
              <div className="mvm-info-cell">
                <span className="mvm-info-label">Code</span>
                <span className="mvm-info-value">{infoMachine.code}</span>
              </div>
            </div>

          </div>

          {/* ── FOOTER ── */}
          <div className="mvm-footer">
            <button className="mvm-close-btn" onClick={() => setShowModal(false)}>
              Cerrar
            </button>
          </div>

        </Modal.Body>

        {/* footer Bootstrap original preservado */}
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cerrar</Button>
        </Modal.Footer>

      </Modal>

      {/* imports no-JSX preservados */}
      {void [useNavigate, useParams, Link, Form, Badge, Container, Row, Col, ListGroup, MachinesFetchAPI, token, user]}
    </>
  )
}

export default ModalviewMachine